

interface RewardBannerProps {
    reward: string;
    gameName?: string;
    compact?: boolean;
}

export default function RewardBanner({ reward, gameName, compact = false }: RewardBannerProps) {
    if (!reward) return null;

    if (compact) {
        return (
            <div className="bg-gradient-to-r from-yellow-500/20 via-orange-500/20 to-yellow-500/20 border border-yellow-500/30 rounded-lg px-3 py-2 flex items-center gap-2">
                <span className="text-lg">🏆</span>
                <span className="text-sm font-medium text-yellow-200 truncate">{reward}</span>
            </div>
        );
    }

    return (
        <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-yellow-600 via-orange-500 to-yellow-600 p-1">
            {/* Inner container */}
            <div className="relative bg-gradient-to-r from-yellow-900/90 via-orange-900/80 to-yellow-900/90 rounded-lg p-4 sm:p-6">
                {/* Shine effect */}
                <div className="absolute inset-0 overflow-hidden rounded-lg">
                    <div
                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full"
                        style={{
                            animation: 'shine 3s ease-in-out infinite',
                        }}
                    />
                </div>

                {/* Content */}
                <div className="relative flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
                    {/* Trophy Icon */}
                    <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/30">
                        <span className="text-2xl sm:text-3xl">🏆</span>
                    </div>

                    {/* Text Content */}
                    <div className="flex-1 text-center sm:text-left">
                        <div className="text-xs uppercase tracking-wider text-yellow-300/80 font-medium mb-1">
                            Win This Reward
                        </div>
                        <div className="text-lg sm:text-xl font-bold text-white">
                            {reward}
                        </div>
                        {gameName && (
                            <div className="text-xs text-yellow-200/60 mt-1">
                                Complete the "{gameName}" bingo challenge
                            </div>
                        )}
                    </div>

                    {/* Decorative stars */}
                    <div className="hidden sm:flex flex-col gap-1 text-yellow-400/50">
                        <span className="text-xl">✨</span>
                        <span className="text-lg ml-2">⭐</span>
                    </div>
                </div>
            </div>

            {/* CSS for shine animation */}
            <style>{`
                @keyframes shine {
                    0% { transform: translateX(-100%); }
                    50%, 100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
}
